import { DEVICE_LIST } from "@/data/devices";

// Trailer (separate product with its own page)
const TRAILER_PRODUCT = {
  id: "anhaenger-750kg",
  name: "PKW-Anhänger (750 kg)",
  tag: "Transport",
  info: "Ideal für Umzüge, Gartenabfälle & Baustoffe. Wahlweise offen oder mit Plane.",
  priceFrom: 27,
  image:
    "https://customer-assets.emergentagent.com/job_anhanger-gear/artifacts/qh803v2j_IMG_6657.jpg",
  href: "/anhaenger",
  imageFit: "cover",
};

// Devices are derived from the central devices list → adding a new device there
// automatically shows it on the homepage grid.
const DEVICE_PRODUCTS = DEVICE_LIST.map((d) => ({
  id: d.slug,
  name: d.shortTitle,
  tag: d.tag,
  info: d.cardInfo,
  priceFrom: d.pricing["4h"],
  image: d.image,
  href: `/geraete/${d.slug}`,
  imageFit: "contain",
}));

export const RENTAL_PRODUCTS = [TRAILER_PRODUCT, ...DEVICE_PRODUCTS];
